"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineEdit = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../");
var utilities_1 = require("../../utilities");
var hooks_1 = require("../../hooks");
var defaultDecoration = { icon: true, underline: true, color: true };
exports.InlineEdit = react_1.forwardRef(function (_a, ref) {
    var _b;
    var Control = _a.control, _c = _a.decoration, decoration = _c === void 0 ? defaultDecoration : _c, onSave = _a.onSave, onCancel = _a.onCancel, onChange = _a.onChange, onClick = _a.onClick, _d = _a.error, errorState = _d === void 0 ? false : _d, _e = _a.actionDirection, actionDirection = _e === void 0 ? 'rb' : _e, _f = _a.actionLayout, actionLayout = _f === void 0 ? 'inline' : _f, className = _a.className, style = _a.style, _g = _a.mode, mode = _g === void 0 ? 'read' : _g, value = _a.value, width = _a.width, showContentOnEdit = _a.showContentOnEdit, Content = _a.content, _h = _a.autoFocusControl, autoFocusControl = _h === void 0 ? true : _h, id = _a.id, focusScopeOptions = _a.focusScopeOptions, props = __rest(_a, ["control", "decoration", "onSave", "onCancel", "onChange", "onClick", "error", "actionDirection", "actionLayout", "className", "style", "mode", "value", "width", "showContentOnEdit", "content", "autoFocusControl", "id", "focusScopeOptions"]);
    var _j = react_1.default.useState(value), newValue = _j[0], setNewValue = _j[1];
    var _k = react_1.default.useState(mode === 'edit'), editing = _k[0], setEditing = _k[1];
    var _l = react_1.default.useState(16), fontsize = _l[0], setFontsize = _l[1];
    var controlRef = react_1.default.useRef(null);
    var saveRef = react_1.default.useRef(null);
    var cancelRef = react_1.default.useRef(null);
    var textRef = react_1.default.useRef(null);
    var getDecoration = function () { return (__assign(__assign({}, defaultDecoration), decoration)); };
    react_1.default.useEffect(function () {
        setNewValue(value);
    }, [value]);
    react_1.default.useEffect(function () {
        if (textRef.current) {
            setFontsize(Number(window
                .getComputedStyle(textRef.current)
                .getPropertyValue('font-size')
                .replace('px', '')));
        }
    }, []);
    var handleOpen = function () {
        if (onClick)
            onClick();
        setEditing(true);
    };
    var handleClose = function () {
        setEditing(false);
    };
    react_1.default.useEffect(function () {
        if (mode === 'edit')
            setEditing(true);
        if (mode === 'read') {
            setEditing(false);
            setNewValue(value);
        }
    }, [mode, value]);
    var InlineEditKeyDown = function (e) {
        var isSpacePressed = e.key === utilities_1.keys.space;
        var isEnterPressed = e.key === utilities_1.keys.enter;
        if (isSpacePressed || isEnterPressed) {
            handleOpen();
            e.preventDefault();
        }
    };
    var handleCancel = function () {
        if (onCancel)
            onCancel();
        setNewValue(value);
        handleClose();
    };
    var handleSave = function () {
        if (errorState)
            return; // if error is true, do not save
        onSave === null || onSave === void 0 ? void 0 : onSave(__assign(__assign({}, controlProps), { value: newValue }));
        handleClose();
    };
    var handleOnChange = function (e, data) {
        if (onChange)
            onChange(e, data);
        if ((e === null || e === void 0 ? void 0 : e.target) instanceof HTMLInputElement ||
            (e === null || e === void 0 ? void 0 : e.target) instanceof HTMLTextAreaElement) {
            setNewValue(data.value);
        }
        else {
            setNewValue(e);
        }
    };
    var escapeOnKeyDown = function (e) {
        var _a;
        var isESCPressed = e.key === utilities_1.keys.esc;
        if (isESCPressed) {
            if (((_a = controlRef.current.state) === null || _a === void 0 ? void 0 : _a.openState) === true) {
                return e;
            }
            handleCancel();
            e.preventDefault();
        }
    };
    var handleTab = hooks_1.useFocusScope([controlRef, saveRef, cancelRef], __assign({ disableAutofocus: true, disableTrapping: actionLayout === 'none', restoreFocusRef: textRef }, focusScopeOptions)).handleTab;
    var handleKeyDown = function (e) {
        handleTab(e);
        escapeOnKeyDown(e);
    };
    var left = ['l', 'lb', 'lt'];
    var bottom = ['b', 'br', 'bl'];
    var top = ['t', 'tr', 'tl'];
    var InlineEditClasses = classnames_1.default('InlineEdit', className, {
        'flex-column': bottom.includes(actionDirection) && actionLayout !== 'floating',
        'flex-column-reverse': top.includes(actionDirection) && actionLayout !== 'floating',
        'flex-row-reverse': left.includes(actionDirection) && actionLayout !== 'floating',
        'InlineEdit--fluid': width === 'fluid',
    });
    var ContentClasses = classnames_1.default('InlineEdit__content', {
        'InlineEdit__content--textcolor': !Content && getDecoration().color,
        'InlineEdit__content--underline': !Content && getDecoration().underline,
        'InlineEdit__content--icon': getDecoration().icon,
        'InlineEdit__content--error': errorState,
    });
    var ActionClasses = classnames_1.default("InlineEdit__action", (_b = {},
        _b["InlineEdit__action--" + actionDirection] = actionLayout !== 'floating',
        _b['InlineEdit__action--floating'] = actionLayout === 'floating',
        _b));
    var EditIconClasses = classnames_1.default('InlineEdit__editIcon c-neutral-80 m-l-half', {
        'InlineEdit__editIcon--small': fontsize <= 16,
        'InlineEdit__editIcon--medium': fontsize <= 26 && fontsize > 16,
        'InlineEdit__editIcon--large': fontsize > 26,
    });
    var getValues = function () {
        var _a;
        var value = newValue;
        if (Content !== undefined)
            return Content();
        if (typeof value === 'string' || typeof value === 'number')
            return value;
        if (Array.isArray(value) && value.length > 0) {
            var valueArray_1 = value.length > 3
                ? value
                    .slice(0, 3)
                    .concat({ text: "+" + (value.length - 3) })
                : value.slice(0, 3);
            var tagArray = function () {
                return valueArray_1.map(function (singleValue, index) {
                    var tagText = singleValue.text
                        ? singleValue.text
                        : typeof singleValue.content === 'string' ||
                            typeof singleValue.content === 'number'
                            ? singleValue.content
                            : String(singleValue.value);
                    return (react_1.default.createElement(__1.Tag, { key: index, color: singleValue.color }, tagText));
                });
            };
            return react_1.default.createElement(__1.TagGroup, null, tagArray());
        }
        return String((_a = value === null || value === void 0 ? void 0 : value.text) !== null && _a !== void 0 ? _a : '');
    };
    var readComponent = (react_1.default.createElement("span", __assign({ className: ContentClasses, ref: textRef, onClick: handleOpen, tabIndex: 0, onKeyDown: InlineEditKeyDown }, props),
        react_1.default.createElement("span", { className: "InlineEdit__value" }, getValues()),
        react_1.default.createElement(__1.Icon, { name: "edit", className: EditIconClasses })));
    var controlProps = {
        id: id,
        className: "InlineEdit__control",
        ref: controlRef,
        error: errorState,
        autoFocus: autoFocusControl,
        onKeyDown: handleKeyDown,
        onChange: handleOnChange,
        value: newValue,
    };
    var internalCompProps = {
        save: handleSave,
        cancel: handleCancel,
        open: editing,
    };
    var actions = (react_1.default.createElement(__1.ButtonGroup, { attached: true, className: ActionClasses, onKeyDown: handleKeyDown },
        react_1.default.createElement(__1.Button, { small: true, ref: saveRef, className: "InlineEdit__save", primary: true, disabled: errorState, onClick: handleSave, type: "submit", iconName: "done" }),
        react_1.default.createElement(__1.Button, { small: true, ref: cancelRef, className: "InlineEdit__cancel", type: "reset", iconName: "clear", onClick: handleCancel })));
    var updateStyle = __assign({ maxWidth: width !== undefined && typeof width === 'string'
            ? "" + width
            : width }, style);
    return (react_1.default.createElement("span", { className: InlineEditClasses, style: updateStyle, ref: ref }, editing ? (actionLayout === 'floating' ? (react_1.default.createElement(__1.Popover, { trigger: Control(controlProps, internalCompProps), portal: true, direction: actionDirection, contentNoPadding: true, padding: null, width: "auto", className: "InlineEdit__floating__body", open: editing, offset: {
            distance: 8,
        }, el: width === 'fluid' ? 'div' : 'span' }, actions)) : (react_1.default.createElement(react_1.default.Fragment, null,
        showContentOnEdit && readComponent,
        Control(controlProps, internalCompProps),
        actionLayout !== 'none' && actions))) : (readComponent)));
});
//# sourceMappingURL=InlineEdit.js.map